import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { b2bLocaleEs } from "../layouts/B2B/i18n";
import { premiumLocaleEs } from "../layouts/Premium/i18n";
import { HOME_USER_LAST_ACTIVITY_TRANSLATION_KEY } from "./constants";
export default {
  es: /*#__PURE__*/_defineProperty({}, HOME_USER_LAST_ACTIVITY_TRANSLATION_KEY, /*#__PURE__*/_objectSpread(/*#__PURE__*/_objectSpread({
    // MyActiveDegree DegreeCard
    DEGREE_START_LABEL: 'Inicio de clases',
    DEGREE_COURSE_COUNT: '{{count}} curso',
    DEGREE_COURSE_COUNT_plural: '{{count}} cursos',
    // MyActiveDegree Events
    NEXT_LIVE_DEGREE_EVENT: 'Tu próximo evento importante...',
    SEE_ALL_DEGREE_EVENTS: 'Ver todos los eventos',
    SCHEDULE_DEGREE_EVENT: 'Agregar a calendario',
    SCHEDULE_DEGREE_EVENT_AGAIN: 'Agendar nuevamente',
    GO_TO_DEGREE_COMPLEMENTARY_SESSION: 'Ir a la sesión',
    GO_TO_DEGREE_COUNSELLING: 'Ir a la asesoría',
    GO_TO_DEGREE_KICKOFF: 'Ir al onboarding',
    GO_TO_EXTERNAL_SESSION: 'Ir al zoom',
    DEGREE_EVENT_DIALOG_TITLE: 'Calendario académico',
    DEGREE_EVENT_DIALOG_DESC: 'Aquí encontrarás la agenda de todos los próximos eventos importantes que se realizarán durante el desarrollo de tu MicroDegree.',
    BOOTCAMP_EVENT_DIALOG_DESC: 'Aquí encontrarás la agenda de todos los próximos eventos importantes que se realizarán durante el desarrollo de tu Bootcamp.',
    // MyActiveDegree Features
    DEGREE_SLACK_TITLE: 'Interactúa con otros estudiantes del MicroDegree',
    BOOTCAMP_SLACK_TITLE: 'Interactúa con otros estudiantes del Bootcamp',
    DEGREE_SLACK_LINK: 'Abrir Slack',
    BOOTCAMP_CHAT_LINK: 'Abrir Discord',
    DEGREE_ATTACHMENTS_TITLE: 'Resuelve tus dudas con nuestras guías del MicroDegree',
    BOOTCAMP_ATTACHMENTS_TITLE: 'Resuelve tus dudas con nuestras guías del Bootcamp',
    DEGREE_ATTACHMENTS_LINK: 'Descargar guías',
    DEGREE_UNAVAILABLE_LINK: 'Próximamente',
    DEGREE_ATTACHMENTS_DIALOG_TITLE: 'Descarga aquí las guías de apoyo',
    // NewCoursesSlider
    NEW_COURSES_SLIDER_TITLE: 'En Crehana tenemos el curso ideal para ti. Conoce nuestros nuevos lanzamientos.',
    NEW_COURSE_TAG: 'Nuevo',
    // BannerPremiumTrial
    PREMIUM_TRIAL_BANNER_TITLE: 'Empieza a disfrutar de Premium gratis por 24 hrs.',
    PREMIUM_TRIAL_BANNER_DESCRIPTION: 'Te hemos dejado unas recomendaciones según tus intereses para que puedas empezar a aprender hoy.',
    PREMIUM_COUPON_TRIAL_BANNER_TITLE: '¡Escoge tu primer curso y empieza la experiencia Premium hoy!',
    PREMIUM_COUPON_TRIAL_BANNER_DESCRIPTION: 'Te hemos dejado unas recomendaciones según tus intereses para que puedas empezar a aprender hoy.',
    PREMIUM_COUPON_TRIAL_DIALOG_TITLE: 'Felicidades, {{name}} ¡Ya tienes acceso por {{count}} día a Crehana Premium!',
    PREMIUM_COUPON_TRIAL_DIALOG_TITLE_plural: 'Felicidades, {{name}} ¡Ya tienes acceso por {{count}} días a Crehana Premium!',
    PREMIUM_COUPON_TRIAL_DIALOG_DESCRIPTION: 'Elige tu primer curso y empieza a aprender hoy',
    PREMIUM_COUPON_TRIAL_DIALOG_CTA: 'Empecemos',
    // MyCourses CourseEnrollments
    BOTTOM_COURSES_TITE: 'Tus últimos cursos vistos',
    SIDE_COURSES_TITE: 'Tus cursos',
    B2B_SIDE_COURSES_TITLE: 'Tus cursos asignados',
    HE_SIDE_COURSES_TITLE: 'Cursos de mi ruta',
    COURSES_FILTER_LABEL: 'Filtrar por',
    COURSES_FILTER_ALL: 'Recientes',
    COURSES_FILTER_ASSIGNED: 'Cursos asignados',
    COURSES_FILTER_INITIAL: 'Por empezar',
    COURSES_FILTER_PROGRESS: 'En progreso',
    COURSES_FILTER_COMPLETED: 'Completados',
    PROGRESS_COURSES_EMPTY_TITLE: 'Pronto vas a tener más cursos asignados',
    PROGRESS_COURSES_EMPTY_DESC: 'Comunícate con tu administrador',
    COMPLETED_COURSES_EMPTY_TITLE: 'Aún no tienes cursos completados',
    COMPLETED_COURSES_EMPTY_DESC: 'Recuerda que para obtener tu diploma Crehana debes completar las clases y presentar tu proyecto final.',
    ASSIGNED_COURSES_EMPTY_TITLE: 'Aún no tienes cursos asignados',
    ASSIGNED_COURSES_EMPTY_DESC: 'Comunícate con el administrador de tu organización para comenzar con tu aprendizaje.',
    USER_DASHBOARD_CTA_TITLE: '¿No encuentras tu curso aquí?',
    SEE_ALL_MY_COURSES: 'Ver todos mis cursos',
    // MyCourses RecommendedCourses
    RECOMMENDED_LIST_TITLE: 'Te recomendamos estos cursos',
    RECOMMENDED_LIST_CTA_TITLE: '¡Sigue avanzando!\nMejora otras habilidades creativas.',
    // MyCourses ReferralLinkBlock
    REFERRAL_LINK_TITLE: 'RECOMIENDA PREMIUM Y RECIBE 6 MESES ADICIONALES GRATIS',
    REFERRAL_LINK_BUTTON: 'REFIERE A TUS AMIGOS',
    // ErrorMessage
    COURSES_ERROR: 'Ocurrió un error al obtener tus cursos.',
    NEW_COURSES_ERROR: 'Ocurrió un error al obtener los nuevos cursos.',
    RECOMMENDED_COURSES_ERROR: 'Ocurrió un error al obtener tus cursos recomendados.',
    DEGREE_ERROR: 'Ocurrió un error al obtener la información de tu MicroDegree',
    BOOTCAMP_ERROR: 'Ocurrió un error al obtener la información de tu Bootcamp',
    TRY_AGAIN: 'Intentar nuevamente',
    // Common actions
    GO_TO_CATALOG: 'Ir al catálogo',
    GO_TO_USER_DASHBOARD: 'Ir a mis cursos',
    SEE_ALL_COURSES: 'Ver todos los cursos',
    GO_TO_BOOTCAMP: 'Ir al bootcamp',
    SEE_COURSE_DETAILS: 'Ver detalles',
    ADD_INTERESTS: 'Agregar intereses',
    EDIT_INTERESTS: 'Editar mis intereses',
    // PROJECT CARD
    START_PROJECT: 'Iniciar proyecto',
    EDIT_PROJECT: 'Editar proyecto',
    MATERIAL: 'Material',
    GO_TO_PROJECT: 'Ver proyecto',
    YOUR_LAST_PROJECT: 'Tu último proyecto',
    IT_IS_TIME_TO_CREATE_PROJECT: 'Empieza tu proyecto del curso:',
    IT_IS_TIME_TO_CREATE_PROJECT_MOBILE: 'Inicia tu proyecto final del curso',
    DOWLOAD_MATERIAL: 'Descargar material',
    WATCH_TUTORIAL: 'Ver tutorial',
    FINAL_PROJECT: 'Proyecto final',
    FINAL_PROJECT_DESCRIPTION: 'Inicia tu proyecto final del curso y certifícate',
    TEMPLATES: 'Plantillas',
    FINAL_PROJECT_QUESTION: '¿No sabes cómo iniciar tu proyecto final del curso?',
    DOWNLOAD_TEMPLATE_AND_START_PROJECT: 'Descarga la plantilla e inicia tu proyecto final',
    HOW_TO_UPLOAD_PROJECT_TEXT: 'Te contamos en pasos cómo subir tus proyectos.',
    ORGANIZE_FINAL_PROJECT_WITH_TEMPLATE: ' Organiza tu proyecto final siguiendo esta plantilla.',
    TUTORIAL_TO_UPLOAD_PROJECT_TEXT: 'En este tutorial, te contamos todas las funciones de la subida de proyecto.',
    FOLLOW_TEMPLATE_STEPS: 'Sigue los pasos de la plantilla y organiza tu proyecto final.',
    PROJECT_EMPTY_TITLE: 'Proyecto sin título',
    PROJECT_UPDATED_AT: 'Última actualización {{date}}',
    COMPLETE_FINAL_EXAM: 'Completa el examen final',
    GO_TO_FINAL_EXAM: 'Ir al examen',
    SIDE_EMPTY_VIEW_TITLE: 'Pronto vas a tener más cursos asignados',
    SIDE_EMPTY_VIEW_ALL_CATALOG_DESC: 'Mientras tanto, descubre todo nuestro contenido según tus intereses',
    SIDE_EMPTY_VIEW_ALL_CATALOG_CTA: 'Ver Contenido para ti',
    SIDE_EMPTY_VIEW_ONLY_PANEL_DESC: 'Comunícate con tu administrador',
    MENTOR_CARD_TITLE: 'Mentor'
  }, premiumLocaleEs.es), b2bLocaleEs.es))
};